/**
 * Brodeuses manual reviews — sort, star filter, pagination.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.reviewsReady === 'true') return;
    root.dataset.reviewsReady = 'true';

    const list = root.querySelector('[data-reviews-list]');
    if (!list) return;

    const items = Array.from(list.querySelectorAll('[data-review-item]'));
    const sortSelect = root.querySelector('[data-reviews-sort]');
    const filterSelect = root.querySelector('[data-reviews-filter]');
    const prevBtn = root.querySelector('[data-reviews-prev]');
    const nextBtn = root.querySelector('[data-reviews-next]');
    const pageLabel = root.querySelector('[data-reviews-page-label]');
    const emptyEl = root.querySelector('[data-reviews-empty]');
    const perPage = parseInt(root.dataset.perPage || '4', 10) || 4;

    let page = 1;

    function getFiltered() {
      const starFilter = filterSelect ? filterSelect.value : 'all';
      let filtered = items.slice();

      if (starFilter !== 'all') {
        const star = parseInt(starFilter, 10);
        filtered = filtered.filter((el) => parseInt(el.dataset.rating || '0', 10) === star);
      }

      const sort = sortSelect ? sortSelect.value : 'newest';
      filtered.sort((a, b) => {
        const ra = parseInt(a.dataset.rating || '0', 10);
        const rb = parseInt(b.dataset.rating || '0', 10);
        const da = a.dataset.date || '';
        const db = b.dataset.date || '';
        if (sort === 'highest') return rb - ra || db.localeCompare(da);
        if (sort === 'lowest') return ra - rb || db.localeCompare(da);
        if (sort === 'oldest') return da.localeCompare(db);
        return db.localeCompare(da); // newest
      });

      return filtered;
    }

    function render() {
      const filtered = getFiltered();
      const totalPages = Math.max(1, Math.ceil(filtered.length / perPage));
      if (page > totalPages) page = totalPages;

      items.forEach((el) => {
        el.hidden = true;
        el.classList.remove('is-visible');
      });

      const start = (page - 1) * perPage;
      const visible = filtered.slice(start, start + perPage);
      visible.forEach((el) => {
        el.hidden = false;
        el.classList.add('is-visible');
      });

      if (emptyEl) emptyEl.hidden = filtered.length > 0;
      if (pageLabel) pageLabel.textContent = page + ' / ' + totalPages;
      if (prevBtn) prevBtn.disabled = page <= 1;
      if (nextBtn) nextBtn.disabled = page >= totalPages || filtered.length === 0;

      const pager = root.querySelector('[data-reviews-pager]');
      if (pager) pager.hidden = filtered.length <= perPage;
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        page = 1;
        render();
      });
    }
    if (filterSelect) {
      filterSelect.addEventListener('change', () => {
        page = 1;
        render();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        page = Math.max(1, page - 1);
        render();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        page += 1;
        render();
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-brodeuses-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
